export const MIME_TYPES: {
  FILE: 'application';
  IMAGE: 'image';
  VIDEO: 'video';
  OTHER: 'other';
} = Object.freeze({
  FILE: 'application',
  IMAGE: 'image',
  VIDEO: 'video',
  OTHER: 'other',
});

export const WEB_FILES_PATHNAME = '/web_files';
